import mixpanel from 'mixpanel-browser';
// NODE_ENV is 'development' locally (npm start), 'test' in jest (npm run test-basic),
// and 'production' for all deployed builds (staging + production)
const env = process.env.NODE_ENV;
const skipTracking = env !== 'production';

const analytics = {
    init(token) {
        if (skipTracking) {
            return;
        }
        mixpanel.init(token);
    },
    track(key, options) {
        if (skipTracking) {
            console.log('analytics.track - skipping local', key, options);
            return;
        }
        return mixpanel.track(key, options);
    },
    identify(user_id) {
        if (skipTracking) {
            return;
        }
        mixpanel.identify(user_id);
    },
    set(value) {
        if (skipTracking) {
            return;
        }
        mixpanel.people.set(value);
    },
    pendoInitialize({ visitor, account }) {
        if (skipTracking) {
            console.log('analytics.pendoInitialize - skipping local', visitor, account);
            return;
        }
        if (window.pendo) {
            window.pendo.initialize({
                visitor,
                account
            });
        }
    }
};

export default analytics;
